<app-header
  *ngIf="!isLoaded; else mainContent"
  [isMenuOpened]="true"
></app-header>

<div
  style="
    background-color: white;
    position: absolute;
    top: 0;
    left: 0;
    width: 48px;
    height: 63px;
    z-index: 5;
    display: flex;
    align-items: center;
    justify-content: center;
  "
>
  <mat-icon
    (click)="toggleSidenav()"
    style="
      color: #777777;
      font-size: 36px;
      width: 50%;
      height: 50%;
      cursor: pointer;
    "
    >menu</mat-icon
  >
</div>

<div
  class="router-class"
  *ngIf="!isLoaded"
  [ngClass]="routerClass"

>
  <router-outlet></router-outlet>
</div>
<app-sidemenu (notify)="onNotify($event)"
  [isSidenavOpened]="isSidenavOpened"
  *ngIf="!isLoaded"
></app-sidemenu>

<div
  id="chat"
  style="
    height: 245px;
    flex-direction: column;
    justify-content: space-between;
    position: absolute;
    right: 7px !important;
    bottom: 170px !important;
    z-index: 1;
    outline: none;
    display: flex;
    flex-direction: column;
  "
>
  <!--<app-thematic-filter></app-thematic-filter>
  <app-draw-tools></app-draw-tools>
  <app-screenshot></app-screenshot>
  <app-chat></app-chat>-->
</div>

<ng-template #mainContent>
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
